import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyChooseDoubleRewardsCampaignMetadata from '../selectors/getLoyaltyChooseDoubleRewardsCampaignMetadata'
import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'

/** Couples enrolment and account fetch state to indicate when the enrolment thunk has finished. */
function useLoyaltyChooseDoubleRewardsEnrolmentState(choice?: ChooseDoubleRewardsChoice) {
  const config = useAppSelector(getLoyaltyChooseDoubleRewardsCampaignMetadata)
  const catalogId = choice === 'points' ? config?.doublePointsChoiceId : choice === 'statusCredits' ? config?.doubleStatusCreditsChoiceId : undefined
  const enrolment = useAppSelector(state => catalogId ? state.loyalty.earnDecisionEnrolment[catalogId] : undefined)
  const accountError = useAppSelector(state => state.loyalty.account.error)

  return {
    pending: !!(enrolment?.fetching || (enrolment?.data && !accountError)),
    error: enrolment?.error || (enrolment?.data && accountError),
    succeeded: !!enrolment?.data,
  }
}

export default useLoyaltyChooseDoubleRewardsEnrolmentState
